module.exports = __webpack_public_path__ + "static/media/400394_02.bbb23c84.png";